import { render, staticRenderFns } from "./AdditionalDetails.vue?vue&type=template&id=44306f77&scoped=true"
import script from "./AdditionalDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AdditionalDetails.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AdditionalDetails.vue?vue&type=style&index=0&id=44306f77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44306f77",
  null
  
)

export default component.exports